import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export const AdapterHealthResponse = z.object({
  status: z.enum(['ok', 'degraded', 'down']).describe('The health status of the adapter'),
  type: z.string().describe('The type of the adapter'),
  version: z.string().describe('The version of the adapter'),
}).openapi('AdapterHealthResponse');

export type AdapterHealthResponse = z.infer<typeof AdapterHealthResponse>;
